import type { PortraitPatch, SourcePortrait } from '../../api/authorInsights'
import { PORTRAIT_FIELDS, type PortraitFieldKey } from '../../lib/authorInsights.ts'

export interface PortraitDraft {
  revision: number
  fields: Record<PortraitFieldKey, string | null>
  changed: PortraitFieldKey[]
  reset: PortraitFieldKey[]
}
export function createPortraitDraft(portrait: SourcePortrait): PortraitDraft {
  return { revision: portrait.revision, fields: Object.fromEntries(PORTRAIT_FIELDS.map(([key]) => [key, portrait.fields.find((field) => field.key === key)?.value ?? ''])) as PortraitDraft['fields'], changed: [], reset: [] }
}
export function changePortraitDraft(draft: PortraitDraft, key: PortraitFieldKey, next: string | null): PortraitDraft {
  return {
    ...draft, fields: { ...draft.fields, [key]: next },
    changed: next === null ? (draft.changed ?? []).filter((field) => field !== key) : [...new Set([...(draft.changed ?? []), key])],
    reset: next === null ? [...new Set([...(draft.reset ?? []), key])] : (draft.reset ?? []).filter((field) => field !== key),
  }
}
export function portraitChanges(draft: PortraitDraft): PortraitPatch['fields'] {
  const fields: PortraitPatch['fields'] = {}
  for (const key of draft.changed ?? []) fields[key] = draft.fields[key] ?? ''
  for (const key of draft.reset ?? []) fields[key] = null
  return fields
}
/** После явной сверки обновляем только нетронутые поля, сохраняя намерение редактора. */
export function rebasePortraitDraft(draft: PortraitDraft, fresh: SourcePortrait): PortraitDraft {
  const next = createPortraitDraft(fresh)
  const touched = new Set([...(draft.changed ?? []), ...(draft.reset ?? [])])
  return { ...draft, revision: fresh.revision, fields: Object.fromEntries(PORTRAIT_FIELDS.map(([key]) => [key, touched.has(key) ? draft.fields[key] : next.fields[key]])) as PortraitDraft['fields'] }
}
